import equitasLogo from './logo_equitas.png'
import './App.css'

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={equitasLogo} className="App-logo" alt="logo" />
        <p>
          The Equitas App is currently undergoing maintenance
        </p>
        <p>
          We'll be back shortly
        </p>
      </header>
    </div>
  );
}

export default App;
